/**
 * joins segments with a `/`, with a leading `/`
 *
 * @param segments the path segments to join together. should be string-like
 * @example
 * const path = pathify('Hello', 'there!', '...', 'General', 'Kenobi!')
 * // path = '/Hello/there!/.../General/Kenobi!'
 * @example
 * const path = pathify()
 * // path = '/'
 */
export const pathify = (...segments: any[]): string => `/${segments.join('/')}`
